BaseController = App.loadClass 'core::Angular/UsernameDropdown/BaseController'

class exports.ContactInfoController extends BaseController
    constructor: (@q, @scope, @transitions, @modalInstance, user, states, additionalValidation, @service, @timeout, @window, @ngModal) ->
        super(@scope, @transitions, @modalInstance, @service)

        @scope.title = 'Edit Contact Info'
        @scope.states = states.states
        @scope.user = user
        @scope.additionalValidation = additionalValidation

        @timeout () ->
            angular.element(@window).trigger 'resize'

        @scope.isCanadian = window.Config.get('app.locale') is 'en_CA'

        @scope.initialPhoneNumber = if user.phone? then user.phone.replace(/[\D]+/g, '') else null
        if not additionalValidation
            @service.phoneNumberConfirmed().then (response) =>
                @scope.phoneNumberConfirmed = !!response.data

    cancel: () =>
        @scope.user.phone = if @scope.user.phone? then @scope.user.phone.replace(/[\D]+/g, '')

        if @scope.initialPhoneNumber isnt @scope.user.phone
            @service.updateUnconfirmedNumber(@scope.initialPhoneNumber)

        @modalInstance.dismiss('cancel')

    saveRequest: (pretend = false) =>
        @service.saveContact(pretend, @scope.user, @scope.additionalValidation).then (response) =>
            jsr = response.data
            if not pretend
                if not @scope.additionalValidation
                    @scope.$root.$broadcast 'username.dropdown.contactInfo:save', @scope.user
                @closeWithAlert jsr.status

    save: (pretend = false) =>
        @scope.user.phone = if @scope.user.phone? then @scope.user.phone.replace(/[\D]+/g, '')

        # If we've previously had a phone number confirmed and the phone number has changed, we need to re-confirm it
        if not pretend and @scope.initialPhoneNumber isnt @scope.user.phone and @scope.phoneNumberConfirmed and !!@scope.user.phone
            @service.updateUnconfirmedNumber(@scope.user.phone).then () =>
                @ngModal.launchSecurityCodeDialog().modalRef.result.then () => @saveRequest pretend
        else
            if not pretend
                @scope.setAlert({ msg: 'Saving Contact Info...', type: 'info' })

            @saveRequest pretend

